// /opt/isp_erp/frontend/src/pages/admin/clientes/ClientesPorEstado.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "../../../api/axios";
import "./ClientesPorEstado.css";

export default function ClientesPorEstado() {
  const { estado } = useParams(); // 'activos' o 'retirados'
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Mapeo de parámetro de URL a valor de estado en BD
  const estadoMap = {
    activos: "ACTIVO",
    retirados: "RETIRADO"
  };

  const estadoReal = estadoMap[estado];
  const titulo = estado === 'activos' ? 'Clientes Activos' : 'Clientes Retirados';
  const icono = estado === 'activos' ? '✅' : '📦';

  useEffect(() => {
    const fetchClientes = async () => {
      setLoading(true);
      setError(null);

      try {
        console.log(`Cargando clientes con estado: ${estadoReal}`);
        const res = await axios.get(`/customers?estado=${estadoReal}`);
        console.log("Clientes recibidos:", res.data);
        setClientes(res.data);
      } catch (err) {
        console.error("Error cargando clientes:", err);
        setError(err.response?.data?.detail || "Error al cargar clientes");
      } finally {
        setLoading(false);
      }
    };

    if (estadoReal) {
      fetchClientes();
    } else {
      setError("Estado no válido");
      setLoading(false);
    }
  }, [estado, estadoReal]);

  if (loading) {
    return (
      <div className="estado-loading-container">
        <div className="estado-loading-spinner"></div>
        <p>Cargando {titulo}...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="estado-error-container">
        <div className="estado-error-card">
          <div className="estado-error-icon">❌</div>
          <h3>Error</h3>
          <p>{error}</p>
          <Link
            to="/clientes/usuarios"
            className="estado-btn-primary"
          >
            ← Volver a Clientes
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="estado-container">
      {/* Header */}
      <div className="estado-header">
        <div className="estado-header-left">
          <div className={`estado-header-icon ${estado}`}>
            {icono}
          </div>
          <div>
            <h1>{titulo}</h1>
            <p className="estado-subtitle">Lista de clientes en estado {estado === 'activos' ? 'activo' : 'retirado'}</p>
          </div>
        </div>
        
        <div className="estado-header-actions">
          <Link
            to="/clientes/activos"
            className={`estado-tab-btn ${estado === 'activos' ? 'active' : ''}`}
          >
            ✅ Activos
          </Link>
          <Link
            to="/clientes/retirados"
            className={`estado-tab-btn ${estado === 'retirados' ? 'active' : ''}`}
          >
            📦 Retirados
          </Link>
        </div>
      </div>

      {/* Contador de resultados */}
      <div className="estado-stats">
        <div className="estado-count">
          <span className="count-number">{clientes.length}</span>
          <span className="count-label">{titulo.toLowerCase()}</span>
        </div>
      </div>

      {/* Contenido principal */}
      {clientes.length === 0 ? (
        <div className="estado-empty">
          <div className="estado-empty-icon">{icono}</div>
          <h3>No hay {titulo.toLowerCase()}</h3>
          <p>
            {estado === 'activos'
              ? "No hay clientes activos en este momento."
              : "Los clientes que retires aparecerán aquí."}
          </p>
          <Link to="/clientes/usuarios" className="estado-btn-link">
            Ver todos los clientes
          </Link>
        </div>
      ) : (
        <div className="estado-table-container">
          <table className="estado-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Identificación</th>
                <th>Nombre Completo</th>
                <th>Plan</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {clientes.map((cliente) => (
                <tr key={cliente.id} className="estado-row">
                  <td className="estado-id">#{cliente.id}</td>
                  <td className="estado-identificacion">{cliente.identificacion}</td>
                  <td>
                    <div className="estado-nombre">
                      <span className="estado-avatar">
                        {cliente.nombres?.charAt(0) || '👤'}
                      </span>
                      {cliente.nombres} {cliente.apellidos}
                    </div>
                  </td>
                  <td className="estado-plan">{cliente.plan || 'N/A'}</td>
                  <td>
                    <span className={`estado-badge estado-${cliente.estado?.toLowerCase()}`}>
                      {cliente.estado === 'ACTIVO' && '✅ '}
                      {cliente.estado === 'RETIRADO' && '📦 '}
                      {cliente.estado}
                    </span>
                  </td>
                  <td>
                    <Link
                      to={`/clientes/detalle/${cliente.id}`}
                      className="estado-btn-ver"
                      title="Ver detalles del cliente"
                    >
                      👁️ Ver Detalle
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
